import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import CurrencyFormat from 'react-currency-format';
import { toast } from 'react-toastify';
import { Formik, FormikProps, FormikValues } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import { useCreateEmail, useRegistrationCertainCreate, useRegistrationCertainNewCreate } from '../services';

type Props = {
  isUpdate?: boolean;
  isNew?: boolean;
  setIsNew?: Function;
  show: boolean;
  handleClose: Function;
  actionData: any;
  areasList: any;
  organisation_typeList: any;
  classesBranchList: any;
  paymentList: any;
  periodsList: any;
  paymentInstallmentList: any;
  setActionData: Function;
  refetch: Function;
};

export default function DefiniteRegistration({
  isNew = false,
  setIsNew,
  show,
  handleClose,
  actionData,
  isUpdate = false,
  areasList,
  organisation_typeList,
  classesBranchList,
  paymentList,
  paymentInstallmentList,
  refetch,
  setActionData,
  periodsList,
}: Props) {
  const formikRef = useRef<FormikProps<any>>(null);
  const [isParent, setIsParent] = useState<boolean>(false);
  const registrationSchema = Yup.object().shape({
    //identity: Yup.string().min(11, 'Minimum 11 karakter girin').max(11, 'Maksimum 11 karakter girin').required('T.C Kimlik numarası zorunludur.'),
    //parent_identity: Yup.string().min(11, 'Minimum 11 karakter girin').max(11, 'Maksimum 11 karakter girin').required('T.C Kimlik numarası zorunludur.'),
    date_of_organisation: Yup.string(),
    name_lastname: Yup.string().min(3, 'Minimum 3 karakter girin').max(50, 'Maksimum 50 karakter girin').required('Lütfen adı soyadı belirtin.'),
    //parent_name_lastname: Yup.string().min(3, 'Minimum 3 karakter girin').max(50, 'Maksimum 50 karakter girin').required('Lütfen adı soyadı belirtin.'),
    //address: Yup.string().min(3, 'Minimum 3 karakter girin').required('Lütfen adres bilgisi belirtin.'),
    phone: Yup.object().shape({
      floatValue: Yup.string().min(1).required(),
      formattedValue: Yup.string().min(1).required(),
      value: Yup.string().min(1).required(),
    }),
    /*parent_phone: Yup.object().shape({
      floatValue: Yup.string().min(1).required(),
      formattedValue: Yup.string().min(1).required(),
      value: Yup.string().min(1).required(),
    }),*/
    //email: Yup.string().email('Geçersiz email adresi girdiniz').min(3, 'Minimum 3 karakter').max(50, 'Maksimum 50 karakter').required('Email adresi zorunludur'),
    //parent_email: Yup.string().email('Geçersiz veli email adresi girdiniz').min(3, 'Minimum 3 karakter').max(50, 'Maksimum 50 karakter').required('Email adresi zorunludur'),
    typeof_organisation: Yup.string().test('values', 'message', (value, validationContext) => {
      const { createError, parent } = validationContext;
      if (parent.typeof_organisation == 0 || organisation_typeList?.filter((e: any) => e.id == parent.typeof_organisation).length === 0) {
        return createError({ message: 'Lütfen organizasyon türünü seçin' });
      }
      return true;
    }),
    area: Yup.string().test('values', 'message', (value, validationContext) => {
      const { createError, parent } = validationContext;
      if (parent.area == 0 || areasList?.filter((e: any) => e.id == parent.area).length === 0) {
        return createError({ message: 'Lütfen mekan seçin' });
      }
      return true;
    }),
    //active_season: Yup.string().min(1, 'Lütfen sezon seçin').required('Lütfen sezon seçin'),
    organisation_fee: Yup.object().shape({
      floatValue: Yup.string().min(1).required(),
      formattedValue: Yup.string().min(1).required(),
      value: Yup.string().min(1).required(),
    }),

    // BURADA KALDIM BUNU SİLEREK DEVAM ET

    /*payment_installment: Yup.string().test('values', 'message', (value, validationContext) => {
      const { createError, parent } = validationContext;
      if (parent.payment_installment == 0) {
        return createError({ message: 'Lütfen taksit seçin' });
      }
      return true;
    }),*/
    /*installment_maturity_range: Yup.string().test('values', 'message', (value, validationContext) => {
      const { createError, parent } = validationContext;
      if (parent.installment_maturity_range == 0) {
        return createError({ message: 'Lütfen taksit vade aralığı seçin' });
      }
      return true;
    }),*/
    /*payment_method: Yup.string().test('values', 'message', (value, validationContext) => {
      const { createError, parent } = validationContext;
      if (parent.payment_method == 0) {
        return createError({ message: 'Lütfen ödeme yöntemi seçin' });
      }
      return true;
    }),*/
    /*monthly_date: Yup.mixed().test('ay', 'Geçersiz ay', function (value: any) {
      if (!value) return false; // Boş veya null ise geçerli değil

      // Girilen değeri tamsayıya çeviriyoruz
      const gun = parseInt(value, 10);

      // Ay değeri 1 ila 12 arasında mı kontrol ediyoruz
      return gun >= 1 && gun <= 29;
    }),*/
  });
  const onErrorFetch = (e: any) => e?.response?.data?.message && toast.error(e?.response?.data?.message);
  const onSuccessFetch = (e: any) => {
    toast.success(`${actionData?.name_lastname} kişisine ait organizasyon başarıyla kayda alındı.`);
    dissmisLocation();
    refetch();
  };
  const onSuccessNewFetch = (e: any) => {
    toast.success(`${e?.data[0]?.identity} numaralı ${e?.data[0]?.name_lastname} kişisi başarıyla kesin kaydı yapıldı.`);
    dissmisLocation();
    refetch();
  };

  const { isLoading: certainIsLoading, mutate: certainMutate, reset: resetMutate } = useRegistrationCertainCreate(onErrorFetch, onSuccessFetch);
  const { isLoading: certainNewIsLoading, mutate: certainNewMutate, reset: resetCertainNewMutate } = useRegistrationCertainNewCreate(onErrorFetch, onSuccessNewFetch);
  const { isLoading: createEmailIsLoading, mutate: createEmailMutate, data: createEmailData } = useCreateEmail(onErrorFetch);

  const dissmisLocation = () => {
    formikRef?.current?.resetForm();
    setIsNew && setIsNew(false);
    setActionData();
    handleClose();
  };

  /*const generateEmail = (isParent: boolean) => {
    setIsParent(isParent);
    const { parent_name_lastname, name_lastname } = formikRef?.current?.values;
    createEmailMutate({ name_lastname: isParent ? parent_name_lastname : name_lastname });
  }
    */

  /*useEffect(() => {
    if (createEmailData?.data)
      isParent ? formikRef?.current?.setFieldValue('parent_email', createEmailData?.data) : formikRef?.current?.setFieldValue('email', createEmailData?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createEmailData?.data]);*/

  useEffect(() => {
    if (actionData)
      formikRef?.current?.setValues({
        ...actionData,
        date_of_organisation: moment(actionData).format('YYYY-MM-DD'),
        phone: { formattedValue: actionData?.phone, value: actionData?.phone, floatValue: actionData?.phone },
        /*parent_phone: {
          formattedValue: actionData?.parent_phone ? actionData?.parent_phone : '',
          value: actionData?.parent_phone ? actionData?.parent_phone : '',
          floatValue: actionData?.parent_phone ? actionData?.parent_phone : 0,
        },*/
        typeof_organisation: actionData?.organisation_type?.id,
        organisation_fee: {
          formattedValue: actionData?.organisation_fee ? actionData?.organisation_fee : '',
          value: actionData?.organisation_fee ? actionData?.organisation_fee : '',
          floatValue: actionData?.organisation_fee ? actionData?.organisation_fee : 0,
        },
        //payment_method: actionData?.payment_method?.id ? actionData?.payment_method?.id : 0,
        //monthly_date: actionData?.monthly_date ? actionData?.monthly_date : '',
      });
  }, [actionData]);
  var initialValues = {
    //identity: '',
    //active_season: '21',
    //parent_identity: '',
    name_lastname: '',
    //parent_name_lastname: '',
    date_of_organisation: '',
    //parent_email: '',
    //email: '',
    phone: {
      formattedValue: '',
      value: '',
      floatValue: 0,
    },
    /*parent_phone: {
      formattedValue: '',
      value: '',
      floatValue: 0,
    },*/
    //address: '',
    typeof_organisation: 0,
    area: 0,
    organisation_fee: {
      formattedValue: '',
      value: '',
      floatValue: 0,
    },
    //payment_method: 0,
    //payment_installment: 0,
    //monthly_date: '',
    notes: '',
    private_note: '',
    //installment_maturity_range: 0,
  };
  return (
    <Modal show={show} onHide={dissmisLocation} centered size="lg">
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={registrationSchema}
        onSubmit={(values, { setSubmitting }) => {
          const body = { ...values, isUpdate };
          body.organisation_fee = body.organisation_fee?.floatValue;
          body.phone = body.phone?.value;
          console.log('body : ', body);
          setActionData(body);
          certainMutate(body);

          // if (isNew || actionData?.is_renew) certainNewMutate(body);
          // else certainMutate(body);
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  {actionData?.is_renew ? 'Kaydı Yenile' : isUpdate ? 'Müşteri Kaydı Düzenle' : 'Müşteri Kaydı Oluştur'}
                </h5>
                <button type="button" className="btn-close" onClick={dissmisLocation} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                {/*<div className="row mb-5">
                  <div className="col-md-12">
                    <label className="form-label required">Sezon</label>
                    <select
                      className={`form-select form-select-solid ${errors.active_season && touched.active_season && 'is-invalid border-danger'}`}
                      name="active_season"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.active_season}
                    >
                      <option value={''}>Seçiniz</option>
                      {periodsList?.map((period: any, index: number) => (
                        <option key={index} value={period?.id}>
                          {period?.name} <span className="text-xs text-muted">{period?.is_active && '- Aktif Sezon'}</span>
                        </option>
                      ))}
                    </select>
                  </div>
                </div>*/}
                <div className="row mb-5">
                  {/*
                  <div className="col-md-6">
                    <label className="form-label">T.C Kimlik Numarası</label>
                    <input
                      type="number"
                      name="identity"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.identity}
                      className={`form-control form-control-solid ${errors.identity && touched.identity && 'is-invalid border-danger'}`}
                    />
                  </div>*/}
                </div>

                <div className="row mb-5">
                  <div className="col-md-6 col-xs-12">
                    <label className="form-label required">Organizasyon Türü</label>
                    <select
                      className={`form-select form-select-solid ${errors.typeof_organisation && touched.typeof_organisation && 'is-invalid border-danger'}`}
                      name="typeof_organisation"
                      onChange={(e) => {
                        handleChange(e);
                        //setFieldValue('typeof_organisation', 0);
                      }}
                      onBlur={handleBlur}
                      value={values.typeof_organisation}
                    >
                      <option value={''}>Seçiniz</option>
                      {organisation_typeList?.map((classes: any, index: number) => (
                        <option key={index} value={classes?.id}>
                          {classes?.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 col-xs-12">
                    <label className="form-label required">Mekan</label>
                    <select
                      className={`form-select form-select-solid ${errors.area && touched.area && 'is-invalid border-danger'}`}
                      name="area"
                      onChange={(e) => {
                        handleChange(e);
                        //setFieldValue('area', 0);
                      }}
                      onBlur={handleBlur}
                      value={values.area}
                    >
                      <option value={''}>Seçiniz</option>
                      {areasList?.map((classes: any, index: number) => (
                        <option key={index} value={classes?.id}>
                          {classes?.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/*<div className="col-md-6">
                    <label className="form-label required">Email</label>
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      disabled={createEmailIsLoading}
                      onBlur={handleBlur}
                      value={values.email}
                      className={`form-control form-control-solid ${errors.email && touched.email && 'is-invalid border-danger'}`}
                    />
                    <div className="d-flex justify-content-end">
                      <button type="button" className="btn btn-sm btn-link p-0 " onClick={() => generateEmail(false)}>
                        Email Oluştur
                      </button>
                    </div>
                  </div>*/}
                </div>
                <div className="row mb-5">
                  <div className="col-md-6 col-xs-12">
                    <label className="form-label required">Organizasyon Tarihi</label>
                    <input
                      type="date"
                      name="date_of_organisation"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.date_of_organisation}
                      className={`form-control form-control-solid ${errors.date_of_organisation && touched.date_of_organisation && 'is-invalid border-danger'}`}
                    />
                  </div>

                  <div className="col-md-6 col-xs-12">
                    <label className="form-label required">Organizasyon Ücreti</label>
                    <CurrencyFormat
                      suffix={'₺'}
                      decimalScale={2}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                      className={`form-control form-control-solid ${errors.organisation_fee && touched.organisation_fee && 'is-invalid border-danger'}`}
                      name="organisation_fee"
                      value={values?.organisation_fee?.formattedValue}
                      onValueChange={(e) => formikRef.current?.setFieldValue('organisation_fee', e)}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-md-6 col-xs-12">
                    <label className="form-label  required">Adı Soyadı</label>
                    <input
                      type="text"
                      name="name_lastname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name_lastname}
                      className={`form-control form-control-solid ${errors.name_lastname && touched.name_lastname && 'is-invalid border-danger'}`}
                    />
                  </div>

                  <div className="col-md-6 col-xs-12">
                    <label className="form-label required">Telefon Numarası</label>
                    <CurrencyFormat
                      format="(###) ###-####"
                      mask="_"
                      name={'phone'}
                      onBlur={handleBlur}
                      value={values?.phone?.formattedValue}
                      onValueChange={(e) => formikRef.current?.setFieldValue('phone', e)}
                      className={`form-control form-control-solid ${errors.phone && touched.phone && 'is-invalid border-danger'}`}
                    />
                  </div>
                  {/*<div className="col-md-6 col-xs-12">
                    <label className="form-label required">Ödeme Yöntemi</label>
                    <select
                      className={`form-select form-select-solid ${errors.payment_method && touched.payment_method && 'is-invalid border-danger'}`}
                      name="payment_method"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.payment_method}
                    >
                      <option value={0}>Seçiniz</option>
                      {paymentList?.map((paymentMethod: any, index: number) => (
                        <option key={index} value={paymentMethod?.id}>
                          {paymentMethod?.name}
                        </option>
                      ))}
                    </select>
                  </div>*/}
                </div>
                {/*<div className="row mb-5">
                  <div className="col-md-6">
                    <label className="form-label required">Sınıfı</label>
                    <select
                      className={`form-select form-select-solid ${errors.class && touched.class && 'is-invalid border-danger'}`}
                      name="class"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue('area', 0);
                      }}
                      onBlur={handleBlur}
                      value={values.class}
                    >
                      <option value={''}>Seçiniz</option>
                      {areasList?.map((classes: any, index: number) => (
                        <option key={index} value={classes?.id}>
                          {classes?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label required">Şube</label>
                    <select
                      className={`form-select form-select-solid ${errors.area && touched.area && 'is-invalid border-danger'}`}
                      name="area"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.area}
                    >
                      <option value={''}>Seçiniz</option>
                      {classesBranchList
                        ?.filter((e: any) => Number(e?.classes_id) === Number(values.class))
                        ?.map((classesBranch: any, index: number) => (
                          <option key={index} value={classesBranch?.id}>
                            {classesBranch?.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-md-6">
                    <label className="form-label required">Veli T.C Kimlik Numarası</label>
                    <input
                      type="number"
                      name="parent_identity"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.parent_identity}
                      className={`form-control form-control-solid ${errors.parent_identity && touched.parent_identity && 'is-invalid border-danger'}`}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label  required">Veli Adı Soyadı</label>
                    <input
                      type="text"
                      name="parent_name_lastname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.parent_name_lastname}
                      className={`form-control form-control-solid ${errors.parent_name_lastname && touched.parent_name_lastname && 'is-invalid border-danger'}`}
                    />
                  </div>
                </div>
                <div className="row mb-5">
                  <div className="col-md-6">
                    <label className="form-label required">Veli Telefon Numarası</label>
                    <CurrencyFormat
                      format="(###) ###-####"
                      mask="_"
                      name={'parent_phone'}
                      value={values?.parent_phone?.formattedValue}
                      onValueChange={(e) => formikRef.current?.setFieldValue('parent_phone', e)}
                      onBlur={handleBlur}
                      className={`form-control form-control-solid ${errors.parent_phone && touched.parent_phone && 'is-invalid border-danger'}`}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label required">Veli Email</label>
                    <input
                      type="email"
                      name="parent_email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={createEmailIsLoading}
                      value={values.parent_email}
                      className={`form-control form-control-solid ${errors.parent_email && touched.parent_email && 'is-invalid border-danger'}`}
                    />
                    <div className="d-flex justify-content-end">
                      <button type="button" className="btn btn-sm btn-link p-0 " onClick={() => generateEmail(true)}>
                        Email Oluştur
                      </button>
                    </div>
                  </div>
                </div>
                <div className="mb-5">
                  <label className="form-label">Adres</label>
                  <textarea
                    className={`form-control form-control-solid ${errors.address && touched.address && 'is-invalid border-danger'}`}
                    name="address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.address}
                    rows={3}
                  ></textarea>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-5 ">
                    <label className="form-label required">Taksit</label>
                    <select
                      className={`form-select form-select-solid ${errors.payment_installment && touched.payment_installment && 'is-invalid border-danger'}`}
                      name="payment_installment"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.payment_installment}
                    >
                      <option value={0}>Seçiniz</option>
                      {paymentInstallmentList?.map((paymentInstallment: any, index: number) => (
                        <option key={index} value={paymentInstallment?.id}>
                          {paymentInstallment?.number_of_installments} Taksit - {moment().add(paymentInstallment?.number_of_installments, 'month').format('MMMM YYYY')} Son Taksit
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6 mb-5">
                    <label className="form-label required">Düzenli Ödeme Günü</label>
                    <CurrencyFormat
                      format="##"
                      max={12}
                      min={1}
                      name={'monthly_date'}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.monthly_date}
                      className={`form-control form-control-solid ${errors.monthly_date && touched.monthly_date && 'is-invalid border-danger'}`}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label required">Taksit Vade Aralığı</label>
                    <select
                      className={`form-select form-select-solid ${errors.installment_maturity_range && touched.installment_maturity_range && 'is-invalid border-danger'}`}
                      name="installment_maturity_range"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.installment_maturity_range}
                    >
                      <option value={0}>Seçiniz</option>

                      <option key={1} value={1}>
                        Her ay
                      </option>
                      <option key={2} value={2}>
                        2 ayda bir
                      </option>
                      <option key={3} value={3}>
                        3 ayda bir
                      </option>
                      <option key={4} value={4}>
                        4 ayda bir
                      </option>
                      <option key={5} value={5}>
                        5 ayda bir
                      </option>
                      <option key={6} value={6}>
                        6 ayda bir
                      </option>
                    </select>
                  </div>
                </div>*/}
                <div className="mb-3">
                  <label className="form-label">Genel Not</label>
                  <textarea className="form-control form-control-solid" name="notes" onChange={handleChange} onBlur={handleBlur} value={values.notes} rows={5}></textarea>
                </div>

                <div className="mb-3">
                  <label className="form-label">Özel Not</label>
                  <textarea
                    className="form-control form-control-solid"
                    name="private_note"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.private_note}
                    rows={5}
                  ></textarea>
                </div>

                {console.log('errors', errors)}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={dissmisLocation}>
                  Vazgeç
                </button>
                <button type="submit" className="btn btn-light-success" disabled={isSubmitting}>
                  {actionData?.is_renew ? 'Kaydı Yenile' : isUpdate ? 'Müşteri Kaydını Düzenle' : 'Müşteri Kaydı Oluştur'}
                  {/* {loading && <span className="spinner-border spinner-border-sm align-middle mx-2 text-white"></span>} */}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Modal>
  );
}
